/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TransPb } from "../body/trans";
import { Vector3dPb } from "../eigen_lcm/Vector3d";

export const protobufPackage = "shape_map";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface BoxPb {
  add: boolean;
  boxMin: Vector3dPb | undefined;
  boxMax: Vector3dPb | undefined;
  trans: TransPb | undefined;
}

function createBaseBoxPb(): BoxPb {
  return { add: false, boxMin: undefined, boxMax: undefined, trans: undefined };
}

export const BoxPb = {
  encode(message: BoxPb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.add === true) {
      writer.uint32(8).bool(message.add);
    }
    if (message.boxMin !== undefined) {
      Vector3dPb.encode(message.boxMin, writer.uint32(18).fork()).ldelim();
    }
    if (message.boxMax !== undefined) {
      Vector3dPb.encode(message.boxMax, writer.uint32(26).fork()).ldelim();
    }
    if (message.trans !== undefined) {
      TransPb.encode(message.trans, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BoxPb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBoxPb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.add = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.boxMin = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.boxMax = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.trans = TransPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BoxPb {
    return {
      add: isSet(object.add) ? globalThis.Boolean(object.add) : false,
      boxMin: isSet(object.boxMin) ? Vector3dPb.fromJSON(object.boxMin) : undefined,
      boxMax: isSet(object.boxMax) ? Vector3dPb.fromJSON(object.boxMax) : undefined,
      trans: isSet(object.trans) ? TransPb.fromJSON(object.trans) : undefined,
    };
  },

  toJSON(message: BoxPb): unknown {
    const obj: any = {};
    if (message.add === true) {
      obj.add = message.add;
    }
    if (message.boxMin !== undefined) {
      obj.boxMin = Vector3dPb.toJSON(message.boxMin);
    }
    if (message.boxMax !== undefined) {
      obj.boxMax = Vector3dPb.toJSON(message.boxMax);
    }
    if (message.trans !== undefined) {
      obj.trans = TransPb.toJSON(message.trans);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BoxPb>, I>>(base?: I): BoxPb {
    return BoxPb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BoxPb>, I>>(object: I): BoxPb {
    const message = createBaseBoxPb();
    message.add = object.add ?? false;
    message.boxMin = (object.boxMin !== undefined && object.boxMin !== null)
      ? Vector3dPb.fromPartial(object.boxMin)
      : undefined;
    message.boxMax = (object.boxMax !== undefined && object.boxMax !== null)
      ? Vector3dPb.fromPartial(object.boxMax)
      : undefined;
    message.trans = (object.trans !== undefined && object.trans !== null)
      ? TransPb.fromPartial(object.trans)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
